var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "23",
        height: "23",
        viewBox: "0 0 23 23",
        fill: "none",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_1_3801)" } }, [
        _c("path", {
          attrs: {
            d: "M11.2381 19.2892C17.3139 19.2892 22.2381 15.2888 22.2381 10.3517C22.2381 5.41459 17.3139 1.4142 11.2381 1.4142C5.16235 1.4142 0.238133 5.41459 0.238133 10.3517C0.238133 12.2896 0.99868 14.0814 2.28774 15.5466C2.2061 16.5994 1.7979 17.5361 1.36821 18.2494C1.13188 18.6447 0.891258 18.9626 0.715086 19.1775C0.624852 19.2849 0.556102 19.3665 0.50454 19.4224C0.478758 19.4482 0.461571 19.4697 0.44868 19.4826L0.43579 19.4954C0.238133 19.6931 0.182274 19.9853 0.289696 20.2431C0.397118 20.5009 0.646336 20.6685 0.925633 20.6685C2.15884 20.6685 3.40063 20.2861 4.43188 19.8392C5.41587 19.4095 6.25376 18.8982 6.76509 18.5244C8.13149 19.0185 9.64399 19.2935 11.2381 19.2935V19.2892ZM5.73813 8.9767C6.10281 8.9767 6.45254 9.12157 6.7104 9.37943C6.96827 9.63729 7.11313 9.98703 7.11313 10.3517C7.11313 10.7164 6.96827 11.0661 6.7104 11.324C6.45254 11.5818 6.10281 11.7267 5.73813 11.7267C5.37346 11.7267 5.02372 11.5818 4.76586 11.324C4.508 11.0661 4.36313 10.7164 4.36313 10.3517C4.36313 9.98703 4.508 9.63729 4.76586 9.37943C5.02372 9.12157 5.37346 8.9767 5.73813 8.9767ZM11.2381 8.9767C11.6028 8.9767 11.9525 9.12157 12.2104 9.37943C12.4683 9.63729 12.6131 9.98703 12.6131 10.3517C12.6131 10.7164 12.4683 11.0661 12.2104 11.324C11.9525 11.5818 11.6028 11.7267 11.2381 11.7267C10.8735 11.7267 10.5237 11.5818 10.2659 11.324C10.008 11.0661 9.86313 10.7164 9.86313 10.3517C9.86313 9.98703 10.008 9.63729 10.2659 9.37943C10.5237 9.12157 10.8735 8.9767 11.2381 8.9767ZM15.3631 10.3517C15.3631 9.98703 15.508 9.63729 15.7659 9.37943C16.0237 9.12157 16.3735 8.9767 16.7381 8.9767C17.1028 8.9767 17.4525 9.12157 17.7104 9.37943C17.9683 9.63729 18.1131 9.98703 18.1131 10.3517C18.1131 10.7164 17.9683 11.0661 17.7104 11.324C17.4525 11.5818 17.1028 11.7267 16.7381 11.7267C16.3735 11.7267 16.0237 11.5818 15.7659 11.324C15.508 11.0661 15.3631 10.7164 15.3631 10.3517Z",
            fill: "black",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_1_3801" } }, [
          _c("rect", {
            attrs: {
              width: "22",
              height: "22",
              fill: "white",
              transform: "translate(0.238159 0.0391998)",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }